import {
  TX_TRANSITION_ACTOR_CUSTOMER as CUSTOMER,
  TX_TRANSITION_ACTOR_PROVIDER as PROVIDER,
  CONDITIONAL_RESOLVER_WILDCARD,
  ConditionalResolver,
} from '../../transactions/transaction';

/**
 * Get state data against product process for TransactionPage's UI.
 * I.e. info about showing action buttons, current state etc.
 *
 * @param {*} txInfo detials about transaction
 * @param {*} processInfo  details about process
 */
export const getStateDataForPurchaseProcess = (txInfo, processInfo) => {
  const { transaction, transactionRole, nextTransitions } = txInfo;
  const listing = transaction.listing;

  const isProviderBanned = transaction?.provider?.attributes?.banned;
  const isShippable = transaction?.attributes?.protectedData?.deliveryMethod === 'shipping';
  const _ = CONDITIONAL_RESOLVER_WILDCARD;

  const {
    processName,
    processState,
    states,
    transitions,
    isCustomer,
    actionButtonProps,
    leaveReviewProps,
  } = processInfo;

  return (
    new ConditionalResolver([processState, transactionRole])
      .cond([states.INQUIRY, CUSTOMER], () => {
        const transitionNames = Array.isArray(nextTransitions)
          ? nextTransitions.map(t => t.attributes.name)
          : [];
        const requestAfterInquiry = transitions.REQUEST_PAYMENT_AFTER_INQUIRY;
        const hasCorrectNextTransition = transitionNames.includes(requestAfterInquiry);
        // const showOrderPanel = !isProviderBanned && hasCorrectNextTransition;
        const showOrderPanel = false;
        return { processName, processState, showOrderPanel };
      })
      .cond([states.INQUIRY, PROVIDER], () => {
        return { processName, processState, showDetailCardHeadings: true };
      })
      .cond([states.PURCHASED, CUSTOMER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showActionButtons: true,
          // showExtraInfo: true,
          // primaryButtonProps: actionButtonProps(transitions.MARK_RECEIVED_FROM_PURCHASED, CUSTOMER),
          // secondaryButtonProps: actionButtonProps(transitions.CANCEL_PURCHASE, CUSTOMER),
        };
      })
      // .cond([states.PURCHASED, PROVIDER], () => {
      //   return {
      //     processName,
      //     processState,
      //     showDetailCardHeadings: true,
      //     showActionButtons: true,
      //     showExtraInfo: true,
      //     primaryButtonProps: actionButtonProps(transitions.SHIPMENT_CREATED, PROVIDER),
      //     secondaryButtonProps: actionButtonProps(transitions.DECLINE_PURCHASE, PROVIDER),
      //   };
      // })
      .cond([states.PURCHASED, PROVIDER], () => {
        const actionButtonTranslationId = isShippable
          ? `TransactionPage.${processName}.${PROVIDER}.transition-mark-delivered.actionButtonShipped`
          : `TransactionPage.${processName}.${PROVIDER}.transition-mark-delivered.actionButton`;

        const declineButtonTranslationId = `TransactionPage.${processName}.${PROVIDER}.transition-decline-purchase.actionButton`;

        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showActionButtons: true,
          primaryButtonProps: actionButtonProps(transitions.SHIPMENT_CREATED, PROVIDER, {
            actionButtonTranslationId,
          }),
          secondaryButtonProps: actionButtonProps(transitions.DECLINE_PURCHASE, PROVIDER, {
            declineButtonTranslationId,
          }),
        };
      })
      .cond([states.PAYMENT_EXPIRED, CUSTOMER], () => {
        const paymentExpiredTranslationId = `TransactionPage.${processName}.${CUSTOMER}.transition-payment-expired.actionButton`;
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showActionButtons: true,
          // primaryButtonProps: actionButtonProps(transitions.PAYMENT_EXPIRED, CUSTOMER, {
          //   paymentExpiredTranslationId,
          //   listing,
          // }),
        };
      })
      .cond([states.SHIPMENT_CREATED, PROVIDER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showActionButtons: true,
          showDownloadWaybill: true,
          showTrackShipping: true,
        };
      })
      .cond([states.SHIPMENT_CREATED, CUSTOMER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showActionButtons: true,
          showTrackShipping: true,
        };
      })
      .cond([states.SHIPMENT_DISPATCHED, CUSTOMER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showActionButtons: true,
          showTrackShipping: true,
        };
      })
      .cond([states.SHIPMENT_DISPATCHED, PROVIDER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showActionButtons: true,
          showTrackShipping: true,
        };
      })
      .cond([states.OUT_FOR_DELIVERY, CUSTOMER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showActionButtons: true,
          showTrackShipping: true,
        };
      })
      .cond([states.OUT_FOR_DELIVERY, PROVIDER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showActionButtons: true,
          showTrackShipping: true,
        };
      })
      .cond([states.WAITING_FOR_CONFIRMATION, CUSTOMER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          // showDispute: true,
          showActionButtons: true,
          secondaryButtonProps: actionButtonProps(transitions.MARK_AS_RECEIVED, CUSTOMER),
        };
      })
      .cond([states.WAITING_FOR_RETURN_CONFIRMATION, PROVIDER], () => {
        const actionButtonTranslationId = `TransactionPage.${processName}.${PROVIDER}.transition-mark-delivered.actionButtonReceived`;
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showDispute: true,
          showActionButtons: true,
          primaryButtonProps: actionButtonProps(transitions.MARK_AS_RETURNED, PROVIDER, {
            actionButtonTranslationId,
          }),
        };
      })
      .cond([states.DELIVERED, CUSTOMER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showDispute: true,
          showActionButtons: true,
          secondaryButtonProps: actionButtonProps(transitions.REQUEST_RETURN, CUSTOMER),
        };
      })
      .cond([states.REQUEST_RETURN, PROVIDER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showActionButtons: true,
          primaryButtonProps: actionButtonProps(transitions.APPROVE_RETURN_REQUEST, PROVIDER),
          secondaryButtonProps: actionButtonProps(transitions.DECLINE_RETURN_REQUEST, PROVIDER),
        };
      })
      .cond([states.RETURN_DECLINED, CUSTOMER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showDispute: true,
        };
      })
      .cond([states.EXPIRE_RETURN_REQUEST, CUSTOMER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showDispute: true,
        };
      })
      .cond([states.RETURN_APPROVED, CUSTOMER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showActionButtons: true,
          primaryButtonProps: actionButtonProps(transitions.RETURN_SHIPMENT_CREATED, CUSTOMER),
        };
      })
      .cond([states.RETURN_SHIPMENT_CREATED, CUSTOMER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showActionButtons: true,
          showDownloadWaybill: true,
          showTrackShipping: true,
        };
      })
      .cond([states.RETURN_SHIPMENT_CREATED, PROVIDER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showActionButtons: true,
          showTrackShipping: true,
        };
      })
      .cond([states.RETURN_ITEM_RECEIVED, PROVIDER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showDispute: true,
          // showActionButtons: true,
          // secondaryButtonPropsButtonProps: actionButtonProps(transitions.REFUND_INITIATED, PROVIDER),
        };
      })
      .cond([states.COMPLETED, _], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showReviewAsFirstLink: true,
          showActionButtons: true,
          primaryButtonProps: leaveReviewProps,
        };
      })
      .cond([states.REVIEWED_BY_PROVIDER, CUSTOMER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showReviewAsSecondLink: true,
          showActionButtons: true,
          primaryButtonProps: leaveReviewProps,
        };
      })
      .cond([states.REVIEWED_BY_CUSTOMER, PROVIDER], () => {
        return {
          processName,
          processState,
          showDetailCardHeadings: true,
          showReviewAsSecondLink: true,
          showActionButtons: true,
          primaryButtonProps: leaveReviewProps,
        };
      })
      .cond([states.REVIEWED, _], () => {
        return { processName, processState, showDetailCardHeadings: true, showReviews: true };
      })
      .default(() => {
        // Default values for other states
        return { processName, processState, showDetailCardHeadings: true };
      })
      .resolve()
  );
};
